export enum AccountGroupTarget {
    ASSET = 'asset',
    LIABILITY = 'liability',
    PROFIT_AND_LOSS = 'profit_and_loss'
}
